<div #chartContainer class="echarts-container" style="width: 100%; height: 460px;">
  <div echarts [options]="echartsOptions" (chartInit)="onChartInit($event)" style="width: 100%; height: 100%;"></div>
</div>
